"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartAddPackagingVariantClick = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartAddPackagingVariantClick(clickElementText, clickText) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: enums_1.EventLabelCartButtonClickEnum.AddPackagingVariant,
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: clickElementText,
            click_text: clickText,
        },
    });
}
exports.trackCartAddPackagingVariantClick = trackCartAddPackagingVariantClick;
//# sourceMappingURL=trackCartAddPackagingVariantClick.js.map